export default __webpack_public_path__ + "static/media/asset02.48ffd254.png";